module.exports = __webpack_public_path__ + "static/media/srinivas.1cc5fa02.jpg";